"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createUnderlineTable = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var createUnderlineTable = function createUnderlineTable() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$gridTemplateColu = _ref.gridTemplateColumns,
      gridTemplateColumns = _ref$gridTemplateColu === void 0 ? '1fr 1fr' : _ref$gridTemplateColu,
      _ref$rowPadding = _ref.rowPadding,
      rowPadding = _ref$rowPadding === void 0 ? '0' : _ref$rowPadding,
      _ref$cellPadding = _ref.cellPadding,
      cellPadding = _ref$cellPadding === void 0 ? '8px' : _ref$cellPadding;

  return _styledComponents["default"].div.withConfig({
    componentId: "sc-by7mov-0"
  })(["& > *{padding:", ";display:grid;grid-template-columns:1fr;align-items:center;&:nth-child(n + 2){border-top:solid 1px ", ";}& > *{padding:", ";}@media (", "){grid-template-columns:", ";}}"], rowPadding, function (_ref2) {
    var theme = _ref2.theme;
    return theme.scuttleGray200;
  }, cellPadding, function (_ref3) {
    var theme = _ref3.theme;
    return theme.forLargerThanPhone;
  }, gridTemplateColumns);
};

exports.createUnderlineTable = createUnderlineTable;
//# sourceMappingURL=underline-table.js.map